import React from 'react';
import { Asterisk as AsteriskIcon } from '@wix/wix-ui-icons-common/system';
import { dataHooks } from '../../constants';
import { st, classes } from './Asterisk.st.css.js';
const Asterisk = ({ labelSize }) => (React.createElement("div", { "aria-hidden": true, "data-hook": dataHooks.asterisk, className: st(classes.root, {
        labelSize,
    }) },
    React.createElement(AsteriskIcon, null)));
export default Asterisk;
//# sourceMappingURL=Asterisk.js.map